import {ErrorHandler, Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, tap, throwError} from "rxjs";
import {CategoryDto} from "../../shared/models/category-dto";
import {PrinterDto} from "../../shared/models/printer-dto";
import {Category} from "../../shared/models/category";
import {PrinterCategoryQueueAssignmentDto} from "../../shared/models/printer-category-queue-assignment-dto";
import {Tenant} from "../../shared/models/tenant";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class PrinterService {

  private baseUrl = environment.apiUrl;
  private baseUrlPrinters = this.baseUrl + 'printers';

  constructor(private http: HttpClient, private errorHandler: ErrorHandler, private _snackBar: MatSnackBar) { }

  getAllPrinters(): Observable<PrinterDto[]> {
    return this.http.get<PrinterDto[]>(`${this.baseUrlPrinters}`).pipe(
      tap(_ => this.log('fetch printers')),
      catchError(this.handleError<PrinterDto[]>('get all printers', []))
    );
  }

  updatePrinter(printer: PrinterDto): Observable<any> {
    return this.http.put<any>(`${this.baseUrlPrinters}`, printer).pipe(
      tap(_ => this.log('put change printer')),
      catchError(this.handleError<PrinterDto[]>('change printer', []))
    );
  }

  createPrinter(printer: PrinterDto): Observable<any> {
    return this.http.post<any>(`${this.baseUrlPrinters}`, printer).pipe(
      tap(_ => this.log('put create printer')),
      catchError(this.handleError<PrinterDto[]>('create printer', []))
    );
  }

  deletePrinter(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlPrinters}/${guid}`).pipe(
      tap(_ => this.log('delete printer')),
      catchError(this.handleError<PrinterDto[]>('delete printer', []))
    );
  }

  getQueuePrintAssignmentsForTenant(): Observable<PrinterCategoryQueueAssignmentDto[]> {
    return this.http.get<PrinterCategoryQueueAssignmentDto[]>(`${this.baseUrlPrinters}/queueassignment`).pipe(
      tap(_ => this.log('fetch print category queue assignments')),
      catchError(this.handleError<PrinterCategoryQueueAssignmentDto[]>('get print category queue assignments', []))
    );
  }

  getAllQueuePrintAssignments(): Observable<PrinterCategoryQueueAssignmentDto[]> {
    return this.http.get<PrinterCategoryQueueAssignmentDto[]>(`${this.baseUrlPrinters}/queueassignment/all`).pipe(
      tap(_ => this.log('fetch print category queue assignments')),
      catchError(this.handleError<PrinterCategoryQueueAssignmentDto[]>('get print category queue assignments', []))
    );
  }

  createQueuePrintAssignment(queuePrinterAssignment: PrinterCategoryQueueAssignmentDto): Observable<any> {
    return this.http.post<any>(`${this.baseUrlPrinters}/queueassignment`, queuePrinterAssignment).pipe(
      tap(_ => this.log('post create printer queue assignment')),
      catchError(this.handleError<PrinterDto[]>('create printer queue assignment', []))
    );
  }

  deleteQueuePrintAssignment(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlPrinters}/queueassignment/${guid}`).pipe(
      tap(_ => this.log('delete queue print category assignment')),
      catchError(this.handleError<PrinterDto[]>('delete queue print category assignment', []))
    );
  }

  getAllTenants(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(`${this.baseUrlPrinters}/tenants`).pipe(
      tap(_ => this.log('fetch tenants')),
      catchError(this.handleError<Tenant[]>('get all tenants', []))
    );
  }

  deleteTenant(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlPrinters}/tenants/${guid}`).pipe(
      tap(_ => this.log('delete tenant')),
      catchError(this.handleError<PrinterDto[]>('delete tenant', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      this.errorHandler.handleError(error);

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      this._snackBar.open('Es ist ein Fehler aufgetreten.', 'Schließen', {duration: 3000});

      // Let the app keep running by returning an empty result.
      return throwError(() => error); //of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`OrderService: ${message}`);
  }

}
